import React, { forwardRef, useEffect, useState } from "react";
import "./MenuDropdown.scss"; // Import CSS file
import { useLazyGetAssignProjectListByUserIdQuery } from "../../../app/services/projectManagementAPI";
import { useSelector } from "react-redux";
import Iconify from "../../../layouts/components/iconify/iconify";
import SidebarModel from "../sidebarModel/SidebarModel";
import { encryptUrlData } from "../../../services/CryptoService";

const CreateTask = React.lazy(() => import("../../../pages/task/CreateTask"));

const MenuDropdown = forwardRef(({isAdmin, anchorEl, onModelOpen, onClose }, ref) => {
  const [headermenu, setHeadermenu] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [taskTypeId, setTaskTypeId] = useState(null);

  const { user } = useSelector((state) => state.auth);

  const [
    getAssignProjectListByUserId,
    { isSuccess: isListSuccess, data: ProjectList },
  ] = useLazyGetAssignProjectListByUserIdQuery();

  const UserID = user.userId;

  useEffect(() => {
    if (UserID) {
      getAssignProjectListByUserId(UserID);
    }
  }, [UserID, getAssignProjectListByUserId]);

  useEffect(() => {
    if (isListSuccess && ProjectList) {
      setHeadermenu(ProjectList);
    }
  }, [isListSuccess, ProjectList]);
  
  const handleToggleModal = () => {
    setShowModal(false);
    onModelOpen?.();
  };

  const onHandleClick = (projectId, typeId) => {
    setShowModal(true);
    onModelOpen?.();
    setSelectedProjectId(projectId);
    setTaskTypeId(typeId);
  };

  return (
    <>
      {anchorEl && (
        <div
          ref={ref}
          className={`menu-dropdown open`}
          style={{
            position: "absolute",
            top: anchorEl.getBoundingClientRect().bottom + window.scrollY || 0,
            left: anchorEl.getBoundingClientRect().left + window.scrollX || 0,
            zIndex: 1000,
            display: headermenu ? "block" : "none",
          }}
        >
          <ul className="menu-list">
            {headermenu?.map((child, index) => (
              <li key={index + 1} className="menu-item">
                <div className="list-item-text">
                  <a
                    href={`/myprojects/tasklist/${encryptUrlData({
                     projectId:child.projectId,projectName:child.projectName,
                     projectCode:child.projectCode
                    }
                    )}`}
                    className="menu-link"
                    rel="noopener noreferrer"
                  >
                    <span>{child.projectName}</span>
                    <Iconify icon="material-symbols:arrow-forward-ios-rounded" />
                  </a>
                </div>
                <ul className="sub-dropdown">
                  <li onClick={() => onHandleClick(child.projectId, 1)}>
                    <span className="subdropdown-list">
                      <div className="menu-icon task-icon">
                        <Iconify icon="charm:tick" />
                      </div>
                      <span className="task-icon">Create Task</span>
                    </span>
                  </li>
                  <li onClick={() => onHandleClick(child.projectId, 2)}>
                    <span className="subdropdown-list">
                      <div className="menu-icon bug-icon">
                        <Iconify icon="ic:round-lens" />
                      </div>
                      <span className="bug-icon">Create Bug</span>
                    </span>
                  </li>
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
      {showModal &&
        (<SidebarModel
          isOpen={showModal}
          onClose={handleToggleModal}
          modalTitle="Create Task"
          modalSize="w-50"
          backdropClosable={false}
        >
          <CreateTask projectId={selectedProjectId} typeId={taskTypeId} onClose={handleToggleModal} />
        </SidebarModel>
        )}
    </>
  );
});

export default MenuDropdown;